import { Shield, Award, Clock, Users } from "lucide-react";

export default function TrustIndicators() {
  return (
    <section className="py-8">
      <h2 className="text-3xl font-bold text-center mb-12">
        Why Choose Homespaces
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <TrustCard
          icon={<Shield className="h-10 w-10" />}
          title="Secure Payments"
          description="All transactions are protected with bank-level security and encryption."
        />
        <TrustCard
          icon={<Award className="h-10 w-10" />}
          title="Verified Properties"
          description="Every listing is verified by our team to ensure quality and accuracy."
        />
        <TrustCard
          icon={<Clock className="h-10 w-10" />}
          title="24/7 Support"
          description="Our customer service team is available around the clock to assist you."
        />
        <TrustCard
          icon={<Users className="h-10 w-10" />}
          title="10,000+ Happy Tenants"
          description="Join thousands of satisfied customers who found their perfect home."
        />
      </div>

      <div className="mt-12 flex flex-wrap justify-center gap-8">
        <PartnerLogo name="Airbnb" />
        <PartnerLogo name="Zillow" />
        <PartnerLogo name="Redfin" />
        <PartnerLogo name="Century 21" />
        <PartnerLogo name="RE/MAX" />
      </div>
    </section>
  );
}

interface TrustCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

function TrustCard({ icon, title, description }: TrustCardProps) {
  return (
    <div className="bg-card rounded-lg p-6 text-center shadow-sm hover:shadow-md transition-shadow">
      <div className="inline-flex items-center justify-center p-2 bg-primary/10 rounded-full text-primary mb-4">
        {icon}
      </div>
      <h3 className="text-xl font-semibold mb-2">{title}</h3>
      <p className="text-muted-foreground">{description}</p>
    </div>
  );
}

function PartnerLogo({ name }: { name: string }) {
  return (
    <div className="flex items-center justify-center bg-muted/50 rounded-lg h-16 w-32 px-4">
      <span className="font-semibold text-muted-foreground">{name}</span>
    </div>
  );
}
